module.exports = __webpack_public_path__ + "static/img/排风机 拷贝.31c4e9d1.png";